import { inject } from "vue";
import ToastService from "../Services/ToastService";
const ToastServiceSymbol = Symbol('ToastServicePlugin');
export const ToastServicePlugin = {
    install: (app) => {
        const toast = app.config.globalProperties.$toast;
        const toastService = new ToastService(toast);
        app.provide(ToastServiceSymbol, toastService);
        app.config.globalProperties.$toastService = toastService;
    },
};
export function useToastService() {
    const spinner = inject(ToastServiceSymbol);
    if (!spinner) {
        throw new Error(`Could not resolve ${ToastServiceSymbol.description}`);
    }
    return spinner;
}
